import React from 'react';
import CreateDealContent from './content';
import CreateDealProvider from 'contexts/create-deal.context/provider';

const CreateDealLayout = () => {
  return (
    <CreateDealProvider>
      <CreateDealContent />
    </CreateDealProvider>
  );
};

export default CreateDealLayout;
